import React, { Component } from 'react';
// import Immutable from 'immutable';
// import Fade from '@material-ui/core/Fade';
// import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import getCardGuests from 'helpers/getCardGuests';
// import RemainingTime from 'components/UI/RemainingTime';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
import { connect } from 'react-redux';
import queryString from 'query-string';
import config from 'config/api';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
// import Snackbar from '@material-ui/core/Snackbar';
// import Container from '@material-ui/core/Container';
// import isArray from 'mout/lang/isArray';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
// import BlockTitle from 'components/UI/BlockTitle';
import BlockRatio from 'components/BlockRatio';
// import getRemainingTime from 'helpers/getRemainingTime';
// import gotoLiveRoom from 'helpers/gotoLiveRoom';
import Spinner from 'components/UI/Spinner';
// import Header from '../Header/Header';
// import Footer from '../Footer';
// import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Template from 'components/UI/Template/Template';
// import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { toHHMM } from 'helpers/time';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import Prettyfier from 'components/UI/Prettyfier';

import { fetchReplay, getReplayData } from './ducks/replay';

import { fetchData, getDataHome, getLoadingError, getReplayEvents } from 'ducks/asyncFetcher';

import { isLoggedIn, getCurrentUserRole, getCurrentUser } from 'ducks/authentication';
// import MuiAlert from '@material-ui/lab/Alert';
import i18n from 'helpers/i18n';
// import { primaryColor } from 'helpers/colors';
import { Link } from 'react-router-dom';

const AF_KEY = 'home';

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

const styles = (theme) => {
  // console.log(theme)
  return {
    root: {
      // color: '#fff',
      // marginBottom: theme.spacing(4),
      // // maxWidth: "1280px",
      // '& .MuiTypography-h2': {
      //   color: 'inherit'
      // },
      // '& .MuiTypography-caption': {
      //   color: 'inherit'
      // },
      // '& .MuiTypography-h6': {
      //   color: 'inherit'
      // },
      '& .MuiTypography-subtitle1': {
        textAlign: 'left',
      },
      '& .MuiSvgIcon-root': {
        verticalAlign: 'middle',
        marginTop: -2
      }

    },
    paperWrapper: {
      width: '100%',
      display: 'block',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        content: "' '",
        height: '160px',
        backgroundColor: theme.palette.replays && theme.palette.replays.backgroundColor ? theme.palette.replays.backgroundColor : theme.palette.primary.light,
        zIndex: -1
      }
    },
    paper: {
      backgroundColor: 'transparent',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      maxWidth: 1024,
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: theme.spacing(4),
      '& a': {
        color: 'inherit'
      }
    },
    inline: {
      display: 'inline-block',
    },

    breadCrumbs: {
      marginTop: theme.spacing(3),
      fontSize: '0.8125rem',
      color: theme.palette.replays && theme.palette.replays.breadCrumbColor ? theme.palette.replays.breadCrumbColor : theme.palette.primary.main,
      '& a': {
        color: theme.palette.replays && theme.palette.replays.breadCrumbColor ? theme.palette.replays.breadCrumbColor : theme.palette.primary.main,
        textDecoration:'underline',
        display: 'inline-block',
        verticalAlign: 'middle',
      },
      // '& span': {
      //   display: 'inline-block',
      //   verticalAlign: 'middle',
      // }
    },

    itemVideo: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(2)
    },
    itemDescription: {
      marginBottom: theme.spacing(2)
    },
    itemDuration: {
      marginBottom: theme.spacing(2)
    },
    itemCopyright: {
      color: theme.palette.primary.main
    },
    itemGuests: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    navWrapper: {
      position: 'relative',
      height: 60
    },
    navButton: {
      position: 'absolute',
      bottom: 0,
    },
    navPrevious: {
      left: 0
    },
    navNext: {
      right: 0
    },
    itemTitle: undefined,
    itemTheme: undefined,
  };
};
class ReplayPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = { logMessage: false };
    // this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
    // this._onMessageSent = this._onMessageSent.bind(this);
    // this._handleSnackbarClose = this._handleSnackbarClose.bind(this);
    // this._runRemainingTimer = this._runRemainingTimer.bind(this);
  }
  componentDidMount() {
    const replayId = this.props.match.params.id;
    const uri = queryString.parse(window.location.search);
    this.props.onMount({ replayId, params: uri });
    // this._startTimer();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.match.params.id !== this.props.match.params.id) {
      const replayId = this.props.match.params.id;
      const uri = queryString.parse(window.location.search);
      this.props.onMount({ replayId, params: uri });
    }
    if (oldProps.$$replayData !== this.props.$$replayData) {
      this._startTimer();
    }
  }
  componentWillUnmount() {
    // this._stopTimer();
  }

  // _stopTimer() {
  //   // console.log('timer stop')
  //   if (this._remainingTimer) {
  //     clearInterval(this._remainingTimer);
  //   }
  // }
  // _startTimer() {
  //   // console.log('timer start')
  //   // const $$card = this._getCard();
  //   // console.log('test1')
  //   if (this._remainingTimer) return;
  //   const $$liveEvent = this._getCard();
  //   // console.log('test2', $e)
  //   if ($$liveEvent === undefined) return;
  //   // console.log('starting timer')
  //   // this._cardTimer = $$card.get('eventDate');
  //   this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
  //   this._runRemainingTimer();
  // }
  // _runRemainingTimer() {
  //   // console.log('run1')
  //   // const { $$card } = this.props;
  //   // const $$liveEvent = $$card;
  //   const $$liveEvent = this._getCard();
  //   // console.log('run2', $e)
  //   if ($$liveEvent === undefined) {
  //     return this._stopTimer();
  //   }
  //   // console.log('run3')
  //   // console.log($e)
  //   // console.log($e.get('eventState'))
  //   const timeRemaining =
  //   $$liveEvent !== undefined && $$liveEvent.get("eventState") != "live"
  //   ? getRemainingTime($$liveEvent.get("eventDate"))
  //   : { days: 0, hours: 0, minutes: 0 };
  //   // console.log(timeRemaining)
  //   if (
  //     timeRemaining.days <= 0 &&
  //     timeRemaining.hours <= 0 &&
  //     timeRemaining.minutes <= 15
  //   ) {
  //     this.setState({ showLiveButton: true }, () => {
  //       // console.log('STOPPPING')
  //       this._stopTimer();
  //     });
  //   } else {
  //     // console.log('RUN')
  //     this.setState({ timeRemaining });
  //   }
  // }

  // _gotoLiveRoom(e) {
  //   // const { $$card } = this.props;
  //   const $$card = this._getFakeCard();
  //   if (e !== undefined && e.preventDefault !== undefined)
  //   e.preventDefault();
  //   gotoLiveRoom($$card, () => {
  //     this._goto('/live/'+$$card.get('id'))
  //   })
  // }
  // _getCard() {
  //   const { $$replayData } = this.props;
  //   // const { id } = match.params;
  //   let found = undefined;
  //   if ($$replayData !== undefined) found = $$replayData;
  //   return found;
  // }

  gotoReplay = (direction) => {
    const {$$card, $$replays} = this.props;
    const index = $$replays.findIndex($$r => $$r.get('id') === $$card.get('id'))
    let newReplay = false;
    const debug = false;
    if (direction === 'next' && index < ($$replays.size-1)) {
      if (debug) console.log('next 1');
      newReplay = $$replays.get(index+1)
    } else if (direction === 'next' && index >= ($$replays.size -1)) {
      if (debug) console.log('next 2');
      newReplay = $$replays.get(0);
    } else if (direction === 'previous' && index > 0) {
      if (debug) console.log('previous 1');
      newReplay = $$replays.get(index-1)
    } else if (direction === 'previous' && index === 0) {
      if (debug) console.log('previous 2');
      newReplay = $$replays.get($$replays.size -1)
    }

    if (!newReplay) return;
    console.log(newReplay.toJS())

    this.props.history.push('/replays/'+newReplay.get('id'));
  }
  render() {
    const { $$data, userRole, classes, $$card, $$replays } = this.props;
    // const { logMessage, showLiveButton } = this.state;
    // const showLiveButton = true;
    // const $$subscriptions =
    // userRole !== undefined &&
    // $$data !== undefined &&
    // $$data !== undefined &&
    // $$data.get('myfutureevents') !== undefined
    // ? $$data.get('myfutureevents').map((e) => e.get('id'))
    // : Immutable.Map();

    // const $$card = this._getCard();
    // const $$card = this._getCard();
    // if ($$card !== undefined)
    // console.log('card is', $$card.toJS())
    // else
    // console.log('CARD IS NOT FOUND !')

    // const timeRemaining =
    // ($$card !== undefined)
    // ? getRemainingTime($$card.get('eventDate'))
    // : {};
    // if ($$card !== undefined)
    // console.log($$card.toJS())
    // else console.log('no card !!')
    // console.log('card is', $$card)
    const $$guests = getCardGuests !== undefined ? getCardGuests($$card) : undefined;

    return (
      <Template current="replays" resize={false}>
        <Box className={classes.paperWrapper} elevation={3}>
          <Paper square elevation={0} className={clsx(classes.root, classes.paper)}>

            <Choose>
              <When condition={$$data !== undefined && userRole === undefined}>
                <Box my={6} align="center">
                  <Typography
                    variant="h5"
                    gutterBottom={true}
                    className={clsx(classes.legend, classes.h6extends)}
                    >
                    Merci de vous connecter pour accéder à ce contenu
                  </Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={(e) => this.props.history.push('/')}
                    >
                    {' '}
                    Connexion
                  </Button>
                </Box>
              </When>
              <When
                condition={
                  $$data !== undefined &&
                  (userRole === 'member' || userRole === 'admin' || userRole === 'staff')
                }
                >
                <If condition={$$card !== undefined}>
                  <Grid container alignContent="center">
                    <Grid item xs={12} className={classes.breadCrumbs}>
                      <Typography variant="subtitle1"><Link to="/">{i18n.get('home', {pretty: false})}</Link>&nbsp;&nbsp;&gt;&nbsp;&nbsp;<Prettyfier text={$$card.get('eventTitle')}/></Typography>
                    </Grid>

                    <Grid item xs={12} >
                      <BlockRatio ratio={'16_9'} className={classes.itemVideo}>
                        <iframe
                          title="replay"
                          src={$$card.get('eventLinkReplay')}
                          className={'embed'}
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay; fullscreen"
                          allowFullScreen
                          />
                      </BlockRatio>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle1" component="div" gutterBottom className={classes.itemTheme}>
                        <Paragrapher
                          text={$$card.get('themeName')}
                          elementClassName={classes.content}
                          prettyfy={true}
                          element={'div'}
                          />
                      </Typography>
                      <Typography variant="h5" component="div" gutterBottom className={classes.itemTitle}>
                        <Paragrapher
                          text={$$card.get('eventTitle')}
                          elementClassName={classes.content}
                          prettyfy={true}
                          element={'div'}
                          />
                      </Typography>
                      <If condition={$$guests !== false && $$guests.size > 0}>
                        <Box className={classes.itemGuests}>
                          <Typography variant={'caption'} gutterBottom style={{marginBottom: 8, display: 'block'}}>{i18n.get('eventAnimatedBy', {pretty: false})}</Typography>
                          {$$guests.map(($$g, aIdx) => {
                            return (
                              <Box w={'100%'} key={'av_'+aIdx} style={{clear: 'both'}}>
                                <Avatar src={$$g.get('dest') !== false ? $$g.get('dest') : undefined} alt={$$g.getIn(['attributes','name'])} style={{float: 'left', marginRight: 8, marginBottom: 8, backgroundColor: '#fff'}}/>
                                <Typography variant={'body1'} >{$$g.getIn(['attributes','name'])}</Typography>
                                <Typography variant={'caption'} gutterBottom>{$$g.getIn(['attributes','description'])}</Typography>
                              </Box>)
                            }).toArray()}
                          </Box>
                        </If>

                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box mt={0} mb={1} px={4}>
                          <If condition={$$card.get('eventDescription')}>
                            <Typography variant="body1" component="div" gutterBottom className={classes.itemDescription}>
                              <Paragrapher
                                text={$$card.get('eventDescription')}
                                elementClassName={classes.content}
                                prettyfy={true}
                                element={'div'}
                                />
                            </Typography>
                          </If>
                          <Typography variant="body1" component="div" gutterBottom className={classes.itemDuration}>
                            <If condition={$$card.get('eventDuration') && $$card.get('eventDuration') !== false && $$card.get('eventDuration') !== false && $$card.get('eventDuration') !== '' && $$card.get('eventDuration') > 0}>
                              <Typography variant="body1" component="div" gutterBottom>
                                <WatchLaterIcon/> {toHHMM($$card.get('eventDuration')*60)}
                                </Typography>
                              </If>
                            </Typography>

                            <Typography variant="caption" className={classes.itemCopyright}>
                              <span className={classes.inline}>{i18n.get('replayCopyrightWarning')}</span>
                            </Typography>
                          </Box>
                        </Grid>
                        <If condition={$$replays !== undefined && $$replays.size > 1}>
                          <Grid item xs={12} className={classes.navWrapper}>
                            <Button variant="outlined" color="secondary" className={clsx(classes.navButton, classes.navPrevious)} onClick={e => this.gotoReplay('previous')}>{i18n.get('replayPrevious',{pretty: false})}</Button>
                            <Button variant="contained" color="primary" className={clsx(classes.navButton, classes.navNext)} onClick={e => this.gotoReplay('next')}>{i18n.get('replayNext',{pretty: false})}</Button>
                          </Grid>
                        </If>
                      </Grid>
                    </If>
                    <If condition={$$card === undefined}>
                      <Box my={8} align="center">
                        <Typography
                          variant="h5"
                          gutterBottom={true}
                          className={clsx(classes.legend, classes.h6extends)}
                          >
                          Il n'y a pas de Replay pour cette webconférence :(
                          </Typography>
                          <Box mt={3}>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => {
                                window.location.replace('/');
                              }}
                              >
                              Cliquez pour retourner à l'accueil
                            </Button>
                          </Box>
                        </Box>
                      </If>
                    </When>
                    <When condition={$$data !== undefined && userRole === 'speaker'}>
                      <p>No place for speaker</p>
                    </When>
                    <Otherwise>
                      <div className={'Loading'}>
                        <Spinner style={{ marginTop: 200 }}>Chargement...</Spinner>
                      </div>
                    </Otherwise>
                  </Choose>
                </Paper>
              </Box>
            </Template>
          );
        }
      }

      function mapStateToProps(state) {
        const props = {
          $$data: getDataHome(state),
          $$replays: getReplayEvents(state),
          error: getLoadingError(state),
          isLoggedIn: isLoggedIn(state),
          userRole: getCurrentUserRole(state),
          $$user: getCurrentUser(state),
          $$card: getReplayData(state),
        };
        return props;
      }
      function mapDispatchToProps(dispatch) {
        return {
          onMount: (props) => {
            dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
            dispatch(fetchReplay(props));
          },
        };
      }

      // export default ;
      export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ReplayPlayer)));



// WEBPACK FOOTER //
// ./src/components/UI/Replays/ReplayPlayer.jsx